var config = require('../config/settings.json');

import Vue from 'vue';
import Tools from "../store/tools.js";
import storage from "../storage/data.js";

export default {
    getAll(context, callback) {
      context.$root.$emit('loading', true);
      context.$http.get(config.api_url + "quizzes").then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    getAllMyQuizzes(context, callback) {
      context.$root.$emit('loading', true);
      context.$http.get(config.api_url + "users/"+storage.data.session.userId+"/quizzes").then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    getBySlug(context,slug, callback) {
      context.$root.$emit('loading', true);
      context.$http.get(config.api_url + "quizzes/"+slug).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    getQuestions(context,slug,callback){
      context.$root.$emit('loading', true);
      context.$http.get(config.api_url + "quizzes/"+slug+"/questions").then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    getAnalysis(context,slug,callback){
      context.$root.$emit('loading', true);
      context.$http.get(config.api_url + "quizzes/"+slug+"/analysis").then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    getResponses(context,slug,callback){
      context.$root.$emit('loading', true);
      context.$http.get(config.api_url + "quizzes/"+slug+"/responses").then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    getPreconizations(context,slug,callback){
      context.$root.$emit('loading', true);
      context.$http.get(config.api_url + "quizzes/"+slug+"/preconizations").then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    getPreconizationById(context,slug,id,callback){
      context.$root.$emit('loading', true);
      context.$http.get(config.api_url + "quizzes/"+slug+"/preconizations/"+id).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    create(context, quiz, callback){
      context.$root.$emit('loading', true);
      var groups = quiz.groups;
      context.$http.post(config.api_url + "quizzes",quiz).then((response) => {
        context.$root.$emit('loading', false);
        callback(response.data,null);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    updateBySlug(context, slug, quiz, callback){
      context.$root.$emit('loading', true);
      context.$http.patch(config.api_url + "quizzes/"+slug,quiz).then((response) => {
        context.$root.$emit('loading', false);
        callback(response.data,null);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    createQuestions(context, slug, questions, callback){
      context.$root.$emit('loading', true);
      context.$http.post(config.api_url + "quizzes/"+slug+"/questions",questions).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    removeQuestionById(context, slugQuiz, idQuestion, callback){
      context.$root.$emit('loading', true);
      context.$http.delete(config.api_url + "quizzes/"+slugQuiz+"/questions/"+idQuestion).then((response) => {
          callback(null); // response.data = null;
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(Tools.translate(response.data));
      });
    },
    removeBySlug(context, slug, callback){
      context.$root.$emit('loading', true);
      context.$http.delete(config.api_url + "quizzes/"+slug).then((response) => {
          // console.log("REMOVE QUIZZ BY SLUG",response.data);
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          console.log("REMOVE QUIZZ BY SLUG ERR",response.data);
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    createResponses(context, slug, responses, callback){
      context.$root.$emit('loading', true);
      context.$http.post(config.api_url + "quizzes/"+slug+"/responses",responses).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    updateAnalysis(context, slug, analysis, callback){
      context.$root.$emit('loading', true);
      context.$http.put(config.api_url + "quizzes/"+slug+"/analysis",analysis).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    createAnalysis(context, slug, analysis, callback){
      context.$root.$emit('loading', true);
      context.$http.post(config.api_url + "quizzes/"+slug+"/analysis",analysis).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    updatePreconizationById(context, slug, id, preconization,callback){
      context.$root.$emit('loading', true);
      context.$http.put(config.api_url + "quizzes/"+slug+"/preconizations/"+id,preconization).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    createPreconization(context, slug, preconization, callback){
      context.$root.$emit('loading', true);
      context.$http.post(config.api_url + "quizzes/"+slug+"/preconizations",preconization).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    removePreconizationById(context, slugQuiz, idPreconization, callback){
      context.$root.$emit('loading', true);
      context.$http.delete(config.api_url + "quizzes/"+slugQuiz+"/preconizations/"+idPreconization).then((response) => {
          callback(null); // response.data = null;
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(Tools.translate(response.data));
      });
    },
    duplicateBySlug(context,slugQuiz,newTitle,callback){
      context.$root.$emit('loading', true);
      context.$http.post(config.api_url + "quizzes/"+slugQuiz+"/duplicate/"+newTitle).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null,Tools.translate(response.data));
      });
    },
    exportPDF(context,slugQuiz,html,callback){
      context.$root.$emit('loading', true);
      context.$http.post(config.api_url + "quizzes/"+slugQuiz+"/exportPDF",{html:html}).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null,Tools.translate(response.data));
      });
    }
}



// WEBPACK FOOTER //
// ./src/requests/quizzes.js